const elements = document.querySelectorAll<HTMLElement>(".accordion-zee__item");
const images = document.querySelectorAll<HTMLElement>(
  "[data-role='zee-image']",
);

const toggleImages = (id: string) => {
  images.forEach((item) => {
    if (item.getAttribute("data-value") !== `item-${id}`) {
      item.classList.add("hidden");
    } else {
      item.classList.remove("hidden");
    }
  });
};

const foo = () => {
  elements.forEach((item) => {
    item.classList.remove("grow");
    item.classList.remove("px-4");
    item.classList.remove("flex");
    item.classList.remove("flex-col");
    item.classList.remove("justify-between");
    const title = item.querySelector("div[data-role='zee-title']");
    const description = item.querySelector("div[data-role='zee-description']");

    if (title == null || description == null) {
      return;
    }

    if (!title.classList.contains("-rotate-90")) {
      title.classList.add("-rotate-90");
      title.classList.add("-translate-x-[105px]");
      title.classList.add("translate-y-[130px]");
      description?.classList.add("hidden");
    }
  });
};

elements.forEach((elm) => {
  elm.onclick = (e) => {
    foo();
    const title = elm.querySelector("div[data-role='zee-title']");
    const description = elm.querySelector("div[data-role='zee-description']");
    const id = elm.getAttribute("data-value");

    if (id) {
      toggleImages(id);
    }

    if (title == null || description == null) {
      return;
    }

    title.classList.toggle("-rotate-90");
    title.classList.remove("-translate-x-[105px]");
    title.classList.remove("translate-y-[130px]");
    description.classList.remove("hidden");
    elm.classList.toggle("grow");
    elm.classList.add("px-4");
    elm.classList.add("flex");
    elm.classList.add("flex-col");
    elm.classList.add("justify-between");
  };
});
